import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  Link,
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
} from "react-router-dom";

import {
  AUTH_ROUTE,
  COACH_PANEL,
  CONTACTS,
  OTP_ROUTE,
  XRAY,
  DASHBOARD,
  FEED,
  ACADEMY,
  COACH_DETAILS,
  QUEST,
  BUSINESS_IMPROVEMENT_PLAN,
  BUSINESS_IMPROVEMENT_PLAN_VIEW,
  STRATEGY_CANVAS,
  STRATEGY_CANVAS_BRIEF,
  STRATEGY_CANVAS_REVIEW,
  STRATEGY_CANVAS_LIVE_REVIEW_WAITING,
  STRATEGY_CANVAS_VIEW,
  EXECUTION_BLUEPRINT,
  EXECUTION_BLUEPRINT_LIVE_REVIEW,
  EXECUTION_BLUEPRINT_REVIEW,
  EXECUTION_BLUEPRINT_WIG_CONNECTIONS,
  EXECUTION_BLUEPRINT_WIG_CONNECTIONS_LOADING,
  EXECUTION_BLUEPRINT_YEAR_ONE_PLAN,
  EXECUTION_BLUEPRINT_LOCKED_VIEW,
  ANNUAL_OKR,
  ANNUAL_OKR_LIVE_REVIEW,
  ANNUAL_OKR_REVIEW,
  ANNUAL_OKR_VIEW_OKRS,
  QUARTERLY_OKR,
  QUARTERLY_OKR_BRIEF,
  QUARTERLY_OKR_REVIEW,
  QUARTERLY_OKR_LIVE_REVIEW,
  QUARTERLY_OKR_SUMMARY,
  QUARTERLY_OKR_SCORECARD,
  COACH_OKR_PLANS,
  COACH_OKR_PLANS_BASE,
  LEGACY_BUSINESS_PLAN,
} from "../../data/RouteUrls";
import * as authActions from "../AuthContainer/_redux/authAction";
import * as coachDetailActions from "../CoachDetails/_redux/coachDetailActions";
import LoadingAnimation from "../../base/LoadingAnimation";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarHeader,
  SidebarContent,
} from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import "./coach-panel.scss";
import Contacts from "./Contacts/Contacts";
import Dashboard from "./Dashboard/Dashboard";
import Xray from "./Xray/Xray";
import { DashboardContainer } from "../shared/DashboardContainer/DashboardContainer";
import { Header } from "./Header/Header";
import Footer from "./Footer/Footer";
import { Academy } from "./Academy/Academy";
import StandardButton from "../shared/formComponents/StandardButton/StandardButton";
import SupportPopup from "../shared/SupportPopup/SupportPopup";
import { FloatingButton } from "../shared/FloatingButton/FloatingButton";
import { Quest } from "./Quest/Quest";
import BusinessImprovementPlanHome from "./BuisnessImprovementPlan/BusinessImprovementPlanHome/BusinessImprovementPlanHome";
import BusinessImprovementPlanView from "./BuisnessImprovementPlan/BusinessImprovementPlanView/BusinessImprovementPlanView";
import StrategyCanvas from "./StrategyCanvas/StrategyCanvas";
import StrategyCanvasBrief from "./StrategyCanvas/StrategyCanvasBrief";
import StrategyCanvasReview from "./StrategyCanvas/StrategyCanvasReview/StrategyCanvasReview";
import StrategyCanvasLiveReviewWaiting from "./StrategyCanvas/StrategyCanvasLiveReviewWaiting/StrategyCanvasLiveReviewWaiting";
import StrategyCanvasView from "./StrategyCanvas/StrategyCanvasView/StrategyCanvasView";
import ExecutionBlueprint from "./ExecutionBlueprint/ExecutionBlueprint";
import ExecutionBlueprintReview from "./ExecutionBlueprint/ExecutionBlueprintReview/ExecutionBlueprintReview";
import ExecutionBlueprintLiveReview from "./ExecutionBlueprint/ExecutionBlueprintLiveReview/ExecutionBlueprintLiveReview";
import AnnualOkr from "./AnnualOkr/AnnualOkr";
import AnnualOkrLiveReview from "./AnnualOkr/AnnualOkrLiveReview/AnnualOkrLiveReview";
import AnnualOkrReview from "./AnnualOkr/AnnualOkrReview/AnnualOkrReview";
import AnnualOkrViewOkrs from "./AnnualOkr/AnnualOkrViewOkrs/AnnualOkrViewOkrs";
import QuarterlyOkrDashboard from "./QuarterlyOkr/QuarterlyOkrDashboard/QuarterlyOkrDashboard";
import QuarterlyOkrBrief from "./QuarterlyOkr/QuarterlyOkrBrief/QuarterlyOkrBrief";
import QuarterlyOkrReview from "./QuarterlyOkr/QuarterlyOkrReview/QuarterlyOkrReview";
import QuarterlyOkrLiveReview from "./QuarterlyOkr/QuarterlyOkrLiveReview/QuarterlyOkrLiveReview";
import QuarterlyOkrSummary from "./QuarterlyOkr/QuarterlyOkrSummary/QuarterlyOkrSummary";
import QuarterlyOkrScorecard from "./QuarterlyOkr/QuarterlyOkrScorecard/QuarterlyOkrScorecard";
import OkrPlansCoach from "./OkrPlans/OkrPlansCoach";
import WigConnections from "./ExecutionBlueprint/ExecutionBlueprintWigConnections/WigConnections";
import WigConnectionsLoading from "./ExecutionBlueprint/ExecutionBlueprintWigConnections/WigConnectionsLoading";
import YearOnePlan from "./ExecutionBlueprint/ExecutionBlueprintYearOnePlan/YearOnePlan";
import LockedBlueprintScreen from "./ExecutionBlueprint/ExecutionBlueprintLocked/LockedBlueprintScreen";
import { useMediaQuery } from "react-responsive";
import { ConditionalRender } from "../shared/ConditionalRender/ConditionalRender";

function WithContainer(props) {
  return (
    <Switch>
      <Route path={props.expandOn}>
        <DashboardContainer expand>{props.children}</DashboardContainer>
      </Route>
      <Route path="/*">
        <DashboardContainer>{props.children}</DashboardContainer>
      </Route>
    </Switch>
  );
}

// ⚠️ LABELS ON THE COLLAPSED RAIL (JK, coach UAT 15-Sep, C57: "the menu bar
// doesn't have labels, so I didn't know where to find the canvas"). When the
// sidebar is collapsed to its icon rail, each item shows its name in a tooltip
// on hover/focus — exactly the SME app's pattern (`PanelContainerNew`'s
// `generateNavItemToolTip`: react-bootstrap `OverlayTrigger`, placement right,
// `.nav-item-tooltip`). Expanded, the label is already visible beside the icon,
// so no tooltip is added.
//
// `MenuItem` is a forwardRef `<li>` that spreads extra props onto itself, so
// OverlayTrigger can attach its ref and hover/focus handlers to it directly.
const RailTooltip = ({ label, show, children }) =>
  show ? (
    <OverlayTrigger
      placement="right"
      overlay={<Tooltip className="nav-item-tooltip">{label}</Tooltip>}
    >
      {children}
    </OverlayTrigger>
  ) : (
    children
  );

const CoachPanel = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const showResponsive = useMediaQuery({ query: "(max-width: 1365px)" });
  const [sideBarOpen, setSideBarOpen] = useState(
    localStorage.getItem("isSidebarOpen") === "true" ? true : false || false,
  );
  const location = useLocation();
  const { pathname } = location;
  const pathnameSplit = pathname.split("/");
  const [showStrategyCanvas, setShowStrategyCanvas] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [showSupportPopup, setShowSupportPopup] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const userProfile = useSelector((state) => state.authDetails.userProfile);

  const toggleSidebar = () => setSidebarCollapsed((prev) => !prev);
  // The rail is icon-only in exactly the state the ProSidebar's
  // `sidebar-close` class is applied (see below).
  const railCollapsed = sideBarOpen || showResponsive;

  const checkForUserProfile = async () => {
    const uspr = await dispatch(authActions.getUserDetails());
    if (!uspr.emailVerified) {
      dispatch(authActions.generateOTP({ email: uspr.email }));
    }
    const coachProfile = await dispatch(coachDetailActions.getCoachProfile());
    if (!coachProfile.companyName) {
      history.push(COACH_DETAILS);
    }
    setShowLoader(false);
  };
  const getCoachAdditionalDetails = async () => {
    try {
      let response = await dispatch(authActions.getCoachAdditionalDetails());
      if (response?.status === 200) {
        setShowStrategyCanvas(response.data.data.show_strategy_canvas);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    checkForUserProfile();
    getCoachAdditionalDetails();
  }, []);

  useEffect(() => {
    if (
      location.pathname.includes("check-in") ||
      // X-Ray respondent chat page (opened in its own tab) needs the full
      // width for the chat + respondent switcher, so force the sidebar
      // collapsed on load rather than respecting whatever was last saved.
      (location.pathname.includes("/x-ray/score/") &&
        location.pathname.includes("/chat/"))
    ) {
      setSideBarOpen(true);
    }
  }, [location.pathname]);

  if (showLoader) return <LoadingAnimation />;
  else if (!userProfile) history.push(AUTH_ROUTE);
  else if (!userProfile.emailVerified) history.push(OTP_ROUTE);
  return (
    <div className="d-flex h-100 coach-panel w-100 position-relative">
      <SupportPopup
        visible={showSupportPopup}
        hidePopup={() => setShowSupportPopup(false)}
      />
      <div
        className={`d-none nxt-d-xl-block position-absolute toggle-main cursor-pointer ${showResponsive || sideBarOpen ? "sidebar-close-toggle" : "sidebar-open-toggle"}`}
        onClick={() => {
          localStorage.setItem("isSidebarOpen", !sideBarOpen);
          setSideBarOpen(!sideBarOpen);
        }}
      >
        <div className="h-100">
          <img
            className={`${!sideBarOpen ? "rotate-180" : ""}`}
            src="/assets/images/right-arrow-active.svg"
          />
        </div>
      </div>
      <ProSidebar
        breakPoint="md"
        toggled={sidebarCollapsed}
        onToggle={toggleSidebar}
        className={sideBarOpen || showResponsive ? "sidebar-close" : ""}
      >
        <SidebarHeader className="text-center">
          <Link to={XRAY}>
            <img
              src={
                sideBarOpen || showResponsive
                  ? "/assets/images/logo-small.png"
                  : "/assets/images/logo.png"
              }
              alt="logo"
              className="mx-auto my-5 main-logo"
            />
          </Link>
        </SidebarHeader>
        <SidebarContent>
          <Menu iconShape="square" className="flex-fill">
            <RailTooltip label="Coach Dashboard" show={railCollapsed}>
              <MenuItem
                active={
                  pathnameSplit[2] === "x-ray" || pathnameSplit[2] === "quest"
                }
                icon={<div className="cs-icon dashboard"></div>}
                onClick={() => setSidebarCollapsed(false)}
              >
                <Link to={XRAY}>Coach Dashboard</Link>
              </MenuItem>
            </RailTooltip>
            <RailTooltip label="Clients" show={railCollapsed}>
              <MenuItem
                active={pathnameSplit[2] === "contacts"}
                icon={<div className="cs-icon contacts"></div>}
                onClick={() => setSidebarCollapsed(false)}
              >
                <Link to={CONTACTS}>Clients</Link>
              </MenuItem>
            </RailTooltip>
            <RailTooltip label="Scaling Resources" show={railCollapsed}>
              <MenuItem
                active={pathnameSplit[2] === "scaling-resources"}
                icon={<div className="cs-icon academy"></div>}
                onClick={() => setSidebarCollapsed(false)}
              >
                <Link to={ACADEMY}>Scaling Resources</Link>
              </MenuItem>
            </RailTooltip>
            <RailTooltip label="User Support" show={railCollapsed}>
              <MenuItem
                icon={<div className="cs-icon support"></div>}
                onClick={() => {
                  setSidebarCollapsed(false);
                  setShowSupportPopup(true);
                }}
              >
                <Link>User Support</Link>
              </MenuItem>
            </RailTooltip>
            {/* OKR Plans (coach) — in the slot the old Business Improvement
                Plans had (removed, OKR_PLANS_COACH.md CD30). Shown to every
                coach. Reuses the "layers" icon until there's a dedicated one. */}
            <RailTooltip label="OKR Plans" show={railCollapsed}>
              <MenuItem
                active={pathnameSplit[2] === "okr-plans"}
                icon={<div className="cs-icon layers"></div>}
                onClick={() => setSidebarCollapsed(false)}
              >
                <Link to={COACH_OKR_PLANS_BASE}>OKR Plans</Link>
              </MenuItem>
            </RailTooltip>
            <ConditionalRender condition={showStrategyCanvas}>
              <RailTooltip label="Strategy Canvas" show={railCollapsed}>
                <MenuItem
                  active={pathnameSplit[2] === "strategy-canvas"}
                  icon={<div className="cs-icon strategy"></div>}
                  onClick={() => setSidebarCollapsed(false)}
                >
                  <Link to={STRATEGY_CANVAS}>Strategy Canvas</Link>
                </MenuItem>
              </RailTooltip>
            </ConditionalRender>
            {/* No backend access flag exists for this yet (unlike
                show_strategy_canvas above) - shown unconditionally until one
                does. See docs/execution-blueprint/PROGRESS.md. */}
            <RailTooltip label="Execution Blueprint" show={railCollapsed}>
              <MenuItem
                active={pathnameSplit[2] === "execution-blueprint"}
                icon={<div className="cs-icon execution"></div>}
                onClick={() => setSidebarCollapsed(false)}
              >
                <Link to={EXECUTION_BLUEPRINT}>Execution Blueprint</Link>
              </MenuItem>
            </RailTooltip>
            {/* Annual OKR — the workflow downstream of the Execution
                Blueprint, so it sits directly below it. Shown unconditionally
                for the same reason: no backend access flag exists for it.
                Icon is `icon_grow.svg`, restroked #056C75 — the same artwork
                the SME app now uses for Annual OKRs, so both sides show one
                mark. See the note in coach-panel.scss. */}
            <RailTooltip label="Annual OKRs" show={railCollapsed}>
              <MenuItem
                active={pathnameSplit[2] === "annual-okrs"}
                icon={<div className="cs-icon annual-okr"></div>}
                onClick={() => setSidebarCollapsed(false)}
              >
                <Link to={ANNUAL_OKR}>Annual OKRs</Link>
              </MenuItem>
            </RailTooltip>
            {/* Quarterly OKRs — downstream of Annual OKRs, so directly below
                it. Its own mark: the quarter pie (`icon_quarterly.svg`). */}
            <RailTooltip label="Quarterly OKRs" show={railCollapsed}>
              <MenuItem
                active={pathnameSplit[2] === "quarterly-okrs"}
                icon={<div className="cs-icon quarterly-okr"></div>}
                onClick={() => setSidebarCollapsed(false)}
              >
                <Link to={QUARTERLY_OKR}>Quarterly OKRs</Link>
              </MenuItem>
            </RailTooltip>
            {/* <MenuItem onClick={() => setSidebarCollapsed(false)}>
              <a href="/knowledge-guide.html" target="_blank">
                <StandardButton
                  color="btn-success guide-btn w-100"
                  bold={true}
                  text={
                    <>
                      <img
                        src="/assets/images/guide.svg"
                        alt="guide"
                        className="me-3"
                      />
                      Guide
                    </>
                  }
                />
              </a>
            </MenuItem> */}
          </Menu>
        </SidebarContent>
      </ProSidebar>
      <div className="flex-fill" style={{ overflow: "auto" }}>
        <div
          className="content-container d-flex flex-column"
          id="content-container"
        >
          <Header setSidebarCollapsed={setSidebarCollapsed} />
          <WithContainer expandOn={[]}>
            <Switch>
              <Route path={CONTACTS} component={Contacts} />
              <Route path={[DASHBOARD, XRAY]} component={Xray} />
              <Route path={QUEST} component={Quest} />
              <Route path={ACADEMY} component={Academy} />
              <Route
                path={STRATEGY_CANVAS_LIVE_REVIEW_WAITING}
                component={StrategyCanvasLiveReviewWaiting}
              />
              <Route
                path={STRATEGY_CANVAS_VIEW}
                component={StrategyCanvasView}
              />
              <Route
                path={STRATEGY_CANVAS_REVIEW}
                component={StrategyCanvasReview}
              />
              <Route
                path={STRATEGY_CANVAS_BRIEF}
                component={StrategyCanvasBrief}
              />
              <Route path={STRATEGY_CANVAS} component={StrategyCanvas} />
              {/* Most-specific first - none of these use `exact`, so
                  EXECUTION_BLUEPRINT would otherwise swallow every child, and
                  .../wig-connections would swallow .../wig-connections/building. */}
              {/* ⚠️ `/year-one-plan/building` MUST stay above
                  `/year-one-plan` — no EXW route uses `exact`, so the shorter
                  path would otherwise swallow the longer one and the drafting
                  wait would never render. The wait screen is the same component
                  as the connectors one; it picks its copy from the step. */}
              {/* The only locked route. The `/locked` hub that used to sit
                  below this one — and forced it to be registered first — was
                  deleted 2026-09-02 on instruction. */}
              <Route
                path={EXECUTION_BLUEPRINT_LOCKED_VIEW}
                component={LockedBlueprintScreen}
              />
              <Route
                path={EXECUTION_BLUEPRINT_YEAR_ONE_PLAN}
                component={YearOnePlan}
              />
              <Route
                path={EXECUTION_BLUEPRINT_WIG_CONNECTIONS_LOADING}
                component={WigConnectionsLoading}
              />
              <Route
                path={EXECUTION_BLUEPRINT_WIG_CONNECTIONS}
                component={WigConnections}
              />
              <Route
                path={EXECUTION_BLUEPRINT_LIVE_REVIEW}
                component={ExecutionBlueprintLiveReview}
              />
              <Route
                path={EXECUTION_BLUEPRINT_REVIEW}
                component={ExecutionBlueprintReview}
              />
              <Route
                path={EXECUTION_BLUEPRINT}
                component={ExecutionBlueprint}
              />
              {/* Annual OKR - coach side. Dashboard, live review, and a read
                  of the OKRs themselves.

                  ⚠️ Most-specific first, and the bare ANNUAL_OKR dashboard
                  route LAST: no route here uses `exact`, so `/annual-okrs`
                  would swallow both children. The two children are siblings
                  (`/review` and `/live-review`) so their order between
                  themselves is free — that was not true of the bare
                  `/:annualOkrId` this replaced. Same trap the EXW block above
                  documents. */}
              <Route
                path={ANNUAL_OKR_LIVE_REVIEW}
                component={AnnualOkrLiveReview}
              />
              <Route
                path={ANNUAL_OKR_VIEW_OKRS}
                component={AnnualOkrViewOkrs}
              />
              <Route path={ANNUAL_OKR_REVIEW} component={AnnualOkrReview} />
              <Route path={ANNUAL_OKR} component={AnnualOkr} />
              {/* Quarterly OKRs — coach side. Siblings under the quarter id;
                  the bare dashboard LAST (nothing here is `exact`). */}
              <Route
                path={QUARTERLY_OKR_LIVE_REVIEW}
                component={QuarterlyOkrLiveReview}
              />
              <Route path={QUARTERLY_OKR_BRIEF} component={QuarterlyOkrBrief} />
              <Route
                path={QUARTERLY_OKR_REVIEW}
                component={QuarterlyOkrReview}
              />
              <Route
                path={QUARTERLY_OKR_SUMMARY}
                component={QuarterlyOkrSummary}
              />
              <Route
                path={QUARTERLY_OKR_SCORECARD}
                component={QuarterlyOkrScorecard}
              />
              <Route path={QUARTERLY_OKR} component={QuarterlyOkrDashboard} />
              {/* OKR Plans (coach) (OkrPlans/OKR_PLANS_COACH.md §8.2). */}
              <Route path={COACH_OKR_PLANS} component={OkrPlansCoach} />
              {/* ⚠️ Never put a pathless component (e.g. `<ConditionalRender>`)
                  between this `Switch` and its `Route`s: `Switch` gives a
                  child without `path` the parent match, so it wins every URL
                  and the redirects below become unreachable (bug fixed
                  2026-09-03). Gate a route with `{cond && <Route/>}` instead. */}
              {/* Old Business Improvement Plans URLs → OKR Plans (CD30). */}
              <Redirect from={LEGACY_BUSINESS_PLAN} to={COACH_OKR_PLANS_BASE} />
              <Route
                path={BUSINESS_IMPROVEMENT_PLAN_VIEW}
                component={BusinessImprovementPlanView}
              />
              <Route
                path={BUSINESS_IMPROVEMENT_PLAN}
                component={BusinessImprovementPlanHome}
              />

              {/* A bare /coach-panel resolves HERE, deliberately, rather
                  than by falling through the wildcard below: it is a real
                  destination (login and the app root both send coaches to
                  it), not an unknown path. */}
              <Redirect exact path={COACH_PANEL} to={XRAY} />
              {/* Unknown paths under the panel. Targets XRAY, not
                  DASHBOARD — /coach-panel/dashboard renders the same Xray
                  screen but is not the URL the sidebar links to, so
                  landing there left the nav item unhighlighted. That path
                  stays routed (see the [DASHBOARD, XRAY] array above) so
                  existing bookmarks keep working. */}
              <Redirect path="/*" to={XRAY} />
            </Switch>
          </WithContainer>
          {/* <Footer /> */}
        </div>
      </div>
      {/* <FloatingButton /> */}
    </div>
  );
};

export default CoachPanel;
